<epic-form-field [text]="textHasDeliveryConfirmation">
	<epic-select
		[control]="form"
		[customSelectedValues]="true">
		<div
			class="epic-select__custom-values"
			selected-values>
			<div
				*ngIf="form.value === 'selected'"
				class="epic-select__selected"
				i18n>
				Yes
			</div>
			<div
				*ngIf="form.value === 'unselected'"
				class="epic-select__selected"
				i18n>
				No
			</div>
		</div>
		<epic-option
			[value]="'selected'"
			[selected]="form.value === 'selected'">
			<span i18n>Yes</span>
		</epic-option>
		<epic-option
			[value]="'unselected'"
			[selected]="form.value === 'unselected'">
			<span i18n>No</span>
		</epic-option>
	</epic-select>
</epic-form-field>
<div class="submit-row">
	<epic-button (click)="submit()">
		<span i18n>Save</span>
	</epic-button>
</div>
